import React from "react";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdCurrencyRupee } from "react-icons/md";
import { Tooltip } from "recharts";
import "../PayinUpload.css";

const Visual = ({
  tableData,
  payoutData,
  payinSettlementData,
  setTableData,
  isLoading,
}) => {
  const groupedData = tableData.reduce((acc, item) => {
    if (!acc[item.userId]) {
      acc[item.userId] = {
        userId: item.userId,
        totalCount: 0,
        totalAmount: 0,
      };
    }

    acc[item.userId].totalCount += Number(item.totalCount);
    acc[item.userId].totalAmount += Number(item.totalAmount);

    return acc;
  }, {});

  const result = Object.values(groupedData);

  return (
    <>
      <div className="visual-wrapper">
        <h3>Payin & total settlement</h3>

        <div className="visual-top-cards">
          <div className="new-section-upload">
            <div className="data-icon-box">
              <p className="heading-new">Total Deposits</p>

              <IoMdInformationCircleOutline className="visual-info-icon my-anchor-element1" />

              <Tooltip
                anchorSelect=".my-anchor-element1"
                place="top"
                className="custom-reduce"
              >
                Total successful payin transactions
              </Tooltip>
            </div>

            <div className="data-icon-box">
              <p className="sub-heading-new">
                ₹{payinSettlementData?.requestAmountSum.toFixed(2)}
              </p>

              <div className="icon-div">
                <MdCurrencyRupee className="visual-currency-icon" />
              </div>
            </div>
          </div>

          <div className="new-section-upload">
            <div className="data-icon-box">
              <p className="heading-new">Total Settlement</p>

              <IoMdInformationCircleOutline className="visual-info-icon my-anchor-element2" />

              <Tooltip
                anchorSelect=".my-anchor-element2"
                place="top"
                className="custom-reduce"
              >
                Total successful transactions settlement amount
              </Tooltip>
            </div>

            <div className="data-icon-box">
              <p className="sub-heading-new">
                ₹{payinSettlementData?.settlementAmountSum.toFixed(2)}
              </p>

              <div className="icon-div">
                <MdCurrencyRupee className="visual-currency-icon" />
              </div>
            </div>
          </div>
        </div>

        <div className="visual-sections-wrapper">
          <div className="visual-left-section">
            <div className="visual-card-list">
              {result.map((item, index) => (
                <div
                  key={index}
                  className="visual-card visual-card-payin"
                >
                  <div className="visual-column">
                    <p className="visual-title">{item.userId}</p>

                    <p className="visual-subtitle">Merchant ID</p>
                  </div>

                  <div className="visual-center-column">
                    <p className="visual-label">Transactions</p>

                    <p className="visual-value">{item.totalCount}</p>
                  </div>

                  <div className="visual-right-column">
                    <p className="visual-label">Amount</p>

                    <p className="visual-value visual-value-success">
                      ₹ {Number(item.totalAmount).toLocaleString("en-IN")}
                    </p>
                  </div>
                </div>
              ))}

              <div className="visual-total-card visual-total-payin">
                <div>
                  <p className="visual-total-title">TOTAL</p>
                </div>

                <div className="visual-total-center">
                  <p className="visual-total-value">
                    {result.reduce(
                      (acc, item) => acc + Number(item.totalCount),
                      0
                    )}
                  </p>
                </div>

                <div className="visual-total-right">
                  <p className="visual-total-value visual-total-success">
                    ₹{" "}
                    {result
                      .reduce(
                        (acc, item) => acc + Number(item.totalAmount),
                        0
                      )
                      .toLocaleString("en-IN")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="visual-right-section">
            {payoutData.map((item, index) => (
              <div
                key={index}
                className="visual-card visual-card-payout"
              >
                <div className="visual-column">
                  <p className="visual-title">{item.name}</p>

                  <p className="visual-subtitle">Merchant Name</p>
                </div>

                <div className="visual-right-column">
                  <p className="visual-label">Total Payout</p>

                  <p className="visual-value visual-value-danger">
                    ₹ {Number(item.totalPayout).toLocaleString("en-IN")}
                  </p>
                </div>
              </div>
            ))}

            <div className="visual-total-card visual-total-payout">
              <div>
                <p className="visual-total-title">TOTAL PAYOUT</p>
              </div>

              <div className="visual-total-right">
                <p className="visual-total-value visual-total-danger">
                  ₹{" "}
                  {payoutData
                    .reduce(
                      (acc, item) => acc + Number(item.totalPayout),
                      0
                    )
                    .toLocaleString("en-IN")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Visual;